//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	// import open from '@/assets/js/openWin'
	import headerBackTitleShare from '@/components/header/headerBackTitleShare'
	import publishTop from '@/components/donateTogether/publishTop'
	// import publishItem from '@/components/donateTogether/publishItem'
	let Base64 = require('js-base64').Base64
	export default {
		components: {
			publishTop,
			headerBackTitleShare
			// publishItem
		},
		data() {
			return {
				imgUrl:require('../assets/images/fpw_logo_small.png'),
				dTDetail: '',
				rankList: [],
				rankSort: 1,
				listTotal: '',
				groupDonationId: this.$route.params.dtId,
				epId: this.$route.params.epId,//527492462491467776
				acr001: this.$route.params.acr001,
				acr002: '',
				planNum: '',
				shareInfo: {},
				details:{},
				isenable:'',
				isQQ:false,
				isBackZcDetail:false,
				listArr:[{
					name:'目标金额/元',
					value:''
				},{
					name:'已募集/元',
					value:''
				},{
					name:'剩余天数/天',
					value:''
				}],
				disableAlert:false,
				tipFlag: 10 //不能支持的标识
			}
		},
		watch:{
			details(){
				this.wechatshareneedkey()
			}
		},
		methods: {
			donateMoney(donateNum) {
				if(donateNum>=1000000){
					let divide = donateNum/10000
					return divide.toFixed(3).slice(0,-1)
				}else{
					return donateNum
				}
			},
			getHeadth (head) {
	      return head.includes("zgshfp.oos-website-cn")?head:this.zc_userhead+head
	    },
			base64(name) {
				return Base64.decode(name.substring(11))
			},
			getNickName(nickName) {
				if (nickName) {
	    		return nickName.includes("WX_NICKNAME")?this.base64(nickName):nickName
	    	}else{
	    		return '爱心人士'
	    	}
	    },
			isenableFun() {
				let data={
	        epId: this.epId,
	        crowdfundingId:this.acr001
	      }
        this.$https.post(this.BASE_URL+"grd/groupDonation/isEnterpriseStatus",data
        )
        .then(res => {
      		if(res.data.code == "GRD-APII0000"){
      			this.isenable = true
      		}else if(res.data.code == "GRD06004"){
      			this.isenable = false
      			this.tipFlag = 4
      		}else if(res.data.code == "GRD-API06005"){
      			this.isenable = false
      			this.tipFlag = 5
      		}else if(res.data.code == "GRD-API06006"){
      			this.isenable = false
      			this.tipFlag = 6
      		}else if(res.data.code == "GRD-API06007"){
      			// 众筹项目待审核
      			this.isenable = false
      			this.tipFlag = 7
      		}else if(res.data.code == "GRD-API06008") {
      			// 众筹项目执行中
      			this.isenable = false
      			this.tipFlag = 8
      		}else if(res.data.code == "GRD-API06009"){
      			// 众筹项目已完成
      			this.isenable = false
      			this.tipFlag = 9
      		}
        })
        .catch(function(err) {
        	console.log(err);
        })
			},
			publishTopData(data) {
				this.details = data
				this.acr002 = data.title
				this.planNum = data.acr014
				console.log(data)
			},
			isAuthorization() {
          window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.wechatAppid+"&redirect_uri="+this.appjump_url+"/pages/index/%23/dTDetail/"+this.groupDonationId+"/"+this.acr001+"/"+this.epId+"/share&scope=snsapi_userinfo&response_type=code&state=wxh5267689457315#wechat_redirect"
			},
			getUrlParamURLysas(name) {
		    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		    var r = window.location.search.substr(1).match(reg);
		    if (r != null){
		        return unescape(r[2]);
		    }
		    return "";
			},
			wxchat () {
        let self = this;
        this.$https.get(this.BASE_URL+'uts/invitationCode/wxAuthorization',{params:{
              'code':this.getUrlParamURLysas("code")
            }}).then( data => {
         	let res = data.data
            if(res.code == 'UTSI0000') {
	            self.zcuserid = res.data.userId;
				self.zctoken = res.data.logintoken;
	            self.zcnickname = res.data.nickname
		          localStorage.setItem('zcuserid',res.data.userId);
		          localStorage.setItem('zcopenid',res.data.openid);
		          localStorage.setItem('zcnickname',res.data.nickname);
		          localStorage.setItem('zctoken',self.zctoken);
            }
        })
      },
      toSupportDetail() {
      	if(this.isWeixinCient()) {
      		if(this.$route.params.isShare == "share") {
      			this.$router.push('/zcprojectDetail/'+this.acr001+'/null/null/null?isShare=share')
      		}else{
      			this.$router.push('/zcprojectDetail/'+this.acr001+'/'+this.G("zcuserid")+'/'+encodeURIComponent(this.G("zcnickname"))+'/null')
      		}
      	}else {
      		// 这是app跳转详情
      		if(this.$route.params.isShare == "details"){
      			// 众筹详情进入
      			this.$router.push('/zcprojectDetail/'+this.acr001+'/'+this.G("zcuserid")+'/'+encodeURIComponent(this.G("zcnickname"))+'/'+this.G("zctoken")+'?histroy=black')
      		}else{
						// 个人中心-我发起的一起捐
      			this.$router.push('/zcprojectDetail/'+this.acr001+'/'+this.G("zcuserid")+'/'+encodeURIComponent(this.G("zcnickname"))+'/'+this.G("zctoken"))
      		}
      	}
      },
			supportBtn() {
				let zcuserid = this.G("zcuserid")
				let zctoken = this.G("zctoken")
				let zcnickname = this.G('zcnickname')
				if(this.isenable) {
					if(this.isWeixinCient()) {
						// 微信 我要支持
						// this.$router.push('/zchelphe/'+this.acr001+'/'+this.planNum+'/'+encodeURIComponent(this.acr002)+'/'+zcuserid+'/'+zctoken+'/'+encodeURIComponent(zcnickname)+'/isDt/'+this.groupDonationId+'/'+this.epId+'/'+encodeURIComponent(this.details.acr036))

						window.location.href = this.appjump_url+'/pages/index/?#/zchelphe/'+this.acr001+'/'+this.planNum+'/'+encodeURIComponent(this.acr002)+'/'+zcuserid+'/'+zctoken+'/'+encodeURIComponent(zcnickname)+'/isDt/'+this.groupDonationId+'/'+this.epId+'/'+encodeURIComponent(this.details.acr036)


					}else {
    				let ua = navigator.userAgent.toLowerCase();
						if(ua.match(/QQ\/[0-9]/i)){
		          this.showToast('','text','请在app或微信内打开！','20em','','')
				      return
				    }else if(ua.match(/WeiBo/i) == "weibo"){
		          this.showToast('','text','请在app或微信内打开！','20em','','')
				      return
				    }
						// APP我要支持
						if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
		          let jsonstr = this.appjump_url+'/pages/index/#/zchelphe/'+this.acr001+'/'+this.planNum+'/'+encodeURIComponent(this.acr002)+'/'+zcuserid+'/'+zctoken+'/'+encodeURIComponent(zcnickname)+'/isDt/'+this.groupDonationId+'/'+this.epId+'/'+encodeURIComponent(this.details.acr036)
		          let strjson='{"jsonstr":"'+jsonstr+'"}';
		          // window.crowdMoney.supportMoeny(strjson);

		          window.native.appLoadUrl(strjson)


		        } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
							this.$router.push('/zchelphe/'+this.acr001+'/'+this.planNum+'/'+encodeURIComponent(this.acr002)+'/'+zcuserid+'/'+zctoken+'/'+encodeURIComponent(zcnickname)+'/isDt/'+this.groupDonationId+'/'+this.epId+'/'+encodeURIComponent(this.details.acr036))
		        }else{
		          this.showToast('','text','请在app或微信内打开！','20em','','')
		        }
					}
				}else{
					if(this.tipFlag ==4){
						// 企业状态不可用
            this.showToast('','text','该企业已被平台禁用暂时不能进行支持','20em','','')
					}else if(this.tipFlag ==6){
		      	this.disableAlert = !this.disableAlert
					}else if(this.tipFlag == 7) {
						// 众筹项目维护
            this.showToast('','text','项目正在维护，暂不能支持','20em','','')
					}else if(this.tipFlag == 8){
						// 众筹项目维护
            this.showToast('','text','项目执行中，不能支持','20em','','')
					}else if(this.tipFlag == 9){
						// 众筹项目维护
            this.showToast('','text','项目已完成，不能支持','20em','','')
					}
					else {
            this.showToast('','text','有点小问题，暂不能支持','20em','','')
					}
				}

			},
			getDtDetail () {
				// 一起捐详情
	   		let data={
	        groupDonationId: this.groupDonationId
	      }
        this.$https.post(this.BASE_URL+"grd/groupDonation/detail",
          this.qs.stringify(data),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          }
        )
        .then(res => {
          this.dTDetail = res.data.data;
          if(this.dTDetail.targetNum>=1000000){
						let divide = this.dTDetail.targetNum/10000
						this.listArr[0].name = '目标金额/万元'
						this.listArr[0].value = divide.toFixed(3).slice(0,-1)
					}else{
          	this.listArr[0].value = this.dTDetail.targetNum
					}
					if(this.dTDetail.donateNum>=1000000){
						let divide = this.dTDetail.donateNum/10000
						this.listArr[1].name = '已募集/万元'
						this.listArr[1].value = divide.toFixed(3).slice(0,-1)
					}else{
         		this.listArr[1].value = this.dTDetail.donateNum
					}
          this.listArr[2].value = this.dTDetail.remainingDays
          this.wechatshareneedkey()
        })
        .catch(function(err) {
        	console.log(err);
        })
	   	},
	   	getStaffRank() {
	   		// 员工排行
				let data={
	        groupdonationId: this.groupDonationId,
	        epId: this.epId,
	        sort: this.rankSort,
	        blcSign: this.DT_QKL,
	        pageIndex:1,
	        pageSize:5
	      }
        this.$https.post(this.BASE_URL+"grd/groupDonation/listOfUserByGroupDonationID",
          data
        )
        .then(res => {
        	this.listTotal = res.data.data.total
          this.rankList.push(...res.data.data.data)
        })
        .catch(function(err) {
        	console.log(err);
        })
			},
			goRank() {
				// 查看全部员工排行
				this.$router.push('/dTRankStaff/'+this.dTDetail.creatorName+'/'+this.groupDonationId+'/'+this.epId+'/'+this.acr001)
			},
			goQKL (data) {
	      if(this.isWeixinCient()){
					window.location.href=data
				}else{
					console.log('{"title":"扶贫区块链","url":"'+data+'&platform=app","navbarHidden":"YES"}');
					window.navigation.pushPage('{"title":"扶贫区块链","url":"'+data+'&platform=app","navbarHidden":"YES"}')
				}
	    },
			timenew(loveTime) {
      	let loTime = this.getDateTimeStamp(loveTime);
      	let minute = 1000 * 60;
        let hour = minute * 60;
        let day = hour * 24;
        let halfamonth = day * 15;
        let month = day * 30;
        let now = new Date().getTime();
        let diffValue = now - loTime;
        if(diffValue < 0){return;}
        let monthC =diffValue/month;
        let weekC =diffValue/(7*day);
        let dayC =diffValue/day;
        let hourC =diffValue/hour;
        let minC =diffValue/minute;
        let time = new Date(loTime);
        if(dayC>1&&monthC<=1){
            loTime=""+ parseInt(dayC) +"天前";
        }
        else if(hourC>=1&&dayC<1){
            loTime=""+ parseInt(hourC) +"小时前";
        }
        else if(minC>=1&&hourC<1){
            loTime=""+ parseInt(minC) +"分钟前";
        }else if(minC<1){
            loTime="刚刚";
        }else{
            loTime= this.formatDate(time)
        }
        return loTime
    	},
    	getDateTimeStamp (dateStr) {
        return Date.parse(dateStr.replace(/-/gi,"/"));
    	},
    	wechatshareneedkey() {
	   		if(this.isWeixinCient()){
	   			let lineLink = window.location.href.split('#')[0];//要分享页面的地址，即该页面地址
	   			this.shareInfo = {
			        title : '社会帮扶，让爱在阳光下连接~',
			        desc: '我们代表'+this.dTDetail.creatorName+'，向「'+this.details.title+'」项目发起一起捐，你也快来参加吧~',
			        link : this.appjump_url+'/pages/index/#/dTDetail/'+this.groupDonationId+'/'+this.acr001+'/'+this.epId+'/share?isSingle=single',
			        imgUrl: this.details.acr065
			    };
			    this.setWeixinConfig(this.shareInfo);
	   		}else{
	   			let title = '社会帮扶，让爱在阳光下连接~'
	   			let desc = '我们代表'+this.dTDetail.creatorName+'，向「'+this.details.title+'」项目发起一起捐，你也快来参加吧~'
	   			this.shareInfo = '{"picurl":"'+this.details.acr065+'","title":"'+title+'","type":"'+2+'","projectId":"'+this.acr001+'","text":"'+desc+'","url":"'+this.appjump_url+'/pages/index/#/dTDetail/'+this.groupDonationId+'/'+this.acr001+'/'+this.epId+'/share?isSingle=single","ischange":'+'"2"'+'}'
	   			// console.log('{"picurl":"'+this.details.acr065+'","title":"'+title+'","type":"'+2+'","projectId":"'+this.acr001+'","text":"'+desc+'","url":"'+this.appjump_url+'/pages/index/#/dTDetail/'+this.dtId+'/'+this.acr001+'/'+this.epId+'/share","ischange":'+'"2"'+'}','eeeeeeeeeeeeeeeeeeeeee')
	   			console.log(this.shareInfo)
	   		}
			}
		},
		created() {
			this.getDtDetail()
			this.getStaffRank()
			this.isenableFun()
    	let ua = navigator.userAgent.toLowerCase();
    	if(ua.match(/QQ\/[0-9]/i)){
	      this.isQQ = true
	    }
			if(this.isWeixinCient()) {
				if(this.$route.params.isShare == "share") {
					if(this.getUrlParamURLysas("code") == null || this.getUrlParamURLysas("code") ==''){
						if(localStorage.getItem('zcopenid') =='undefined' || localStorage.getItem('zcopenid')  == undefined || localStorage.getItem('zcopenid') == '' ||localStorage.getItem('zcopenid') == null){
							this.isAuthorization()
						}
					}else {
						this.wxchat()
					}
				}
				// 微信判断
			}
		},
		mounted() {
    	let ua = navigator.userAgent.toLowerCase();
			if(this.$route.params.isShare == "share") {
				let headback = document.getElementsByClassName('left-arrow')[0]
				let ua = navigator.userAgent.toLowerCase();
				headback.style.display = "none"
			}
			if(ua.match(/QQ\/[0-9]/i)){
				let nopaybtn = document.getElementsByClassName('dTdetail-container')[0]
				nopaybtn.style.bottom = '0px'
			}


		},
		beforeRouteEnter(to, from, next) {
			if(from.name == 'dTPublish'){
				next(vm => {
					vm.isBackZcDetail = true
				})
			}else{
				next()
			}
		},
		beforeRouteLeave (to, from , next) {
		  if (this.isBackZcDetail) {
		    if(to.name == 'zcprojectDetail'){
		    	next()
		    }else{
		    	if(this.isWeixinCient()){
		    		this.$router.push('/zcprojectDetail/'+this.acr001+'/'+this.G("zcuserid")+'/'+this.G("zcnickname")+'/null'+'?headImage='+encodeURIComponent(this.G('zcheadimgurl')))
		    	}else{
		    		this.$router.push('/zcprojectDetail/'+this.acr001+'/'+this.G("zcuserid")+'/'+this.G("zcnickname")+'/'+this.G("zctoken")+'?headImage='+this.G('zcheadimgurl')+"&histroy=black")
		    	}
		    }
		  } else {
		    next()
		  }
		}
	}



// WEBPACK FOOTER //
// ./src/crowd_fund/dTDetail.vue